import PartyPoppers from "./components/Party_Poppers/PartyPoppers";

const App = () => {
  return (
    <div className="app">
      {/* If you want to test different components just place here the main file of that component here from the components folder e.g. <BlogCard/> */}
      <PartyPoppers />
    </div>
  );
};

export default App;
